import styled from "styled-components";

export const SpanTitulo = styled.span`
  color: black;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
`;

export const SpanSubtitulo = styled.span`
  color: black;
  font-size: 18px;
  margin-bottom: 20px;
  display: block;
`;
export const SpanNumeroCar = styled.span`
  color: black;
  font-size: 12px;
  display: block;
`;
export const SpanNomeMunicipioFazenda = styled.span`
  color: black;
  font-size: 12px;
  display: block;
`;

export const DivGeral = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 185mm;
  justify-content: space-between;
`;

export const FolhaA4 = styled.div`
  width: 220mm;
  height: 308mm;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 25mm;
  padding-right: 10mm;
  padding-bottom: 10mm;
  padding-top: 10mm;
  page-break-after: always;
  background: white;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const ContainerTitulo = styled.div`
  width: 156mm;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LogoEmbrapa = styled.img`
  width: 29mm;
  height: 15mm;
`;
export const CorpoPdf = styled.div`
  width: 185mm;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const ImgsContainer = styled.div`
  width: 165mm;
  height: 270mm;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 8mm;
`;
export const TextoCidadeEstadoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

export const TextoNomeCidade = styled.h3`
  color: black;
  margin: 0;
  white-space: nowrap;
`;
export const TextoSiglaEstado = styled.h3`
  color: black;
  margin: 0;
`;

export const TextoAno = styled.h3`
  color: black;
`;

export const TextoLegenda = styled.span`
  color: black;
  font-size: 12px;
`;

export const TextoLegendaNota = styled.span`
  color: #444;
  font-size: 10px;
  text-align: center;
  max-width: 150px;
`;

export const ContainerAnoImg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  rotate: -90deg;
`;
export const ContainerTextoRodape = styled.div`
  width: 10mm;
  position: absolute;
  bottom: 40mm;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const TextoRodape = styled.span`
  width: 200mm;
  font-size: 12px;
  color: black;
  rotate: -90deg;
`;

export const PDFContainer = styled.div`
  width: 185mm;
  height: 288mm;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const Tabela = styled.table`
  width: 185mm;
  border-collapse: collapse;
  border: 1px solid black;
`;

export const LinhaTabela = styled.tr`
  height: 12px;
`;

export const CelulaTabela = styled.td`
  font-size: 12px;
  border: 1px solid black;
  padding: 2px 4px;
  text-align: center;
  vertical-align: middle;
`;

export const TextoAnoTabela = styled.span`
  color: black;
`;

export const TextoHeaderTabela = styled.div`
  height: 90px;
  rotate: -90deg;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 40px;
`;

export const RodapePdf = styled.div`
  width: 185mm;
  display: flex;
  justify-content: space-between;
`;
export const ContainerTextoRodapeH = styled.div`
  color: black;
  font-size: 14px;
`;

export const TextoRodapePdf = styled.div`
  font-size: 14px;
  color: black;
`;

export const MapsContainer = styled.div`
  width: 100%;
  height: 180mm;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  justify-items: center;
  align-content: space-between;
  row-gap: 6mm;
  column-gap: 6mm;
`;

export const LegendaEstadoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 100px;
  padding-left: 20px;
`;

export const TabelaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

export const TextoInfoTabela = styled.span`
  color: black;
`;
